import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// 1. استيراد محركات المصادقة والتخزين التي كانت مفقودة
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// 2. تطبيق معمارية البيئة (Environment Variables) مع وجود قيم احتياطية
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBUqOC52AIHV-MI9fjBvle3hyMduMPy71o",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tamkeen-platform-410cf.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tamkeen-platform-410cf",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tamkeen-platform-410cf.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "324401527472",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:324401527472:web:949add41e94ce6a60b1975"
};

// تهيئة الاتصال السحابي
const app = initializeApp(firebaseConfig);

// 3. تهيئة المحركات الثلاثة بشكل متزامن
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// 4. تصدير جميع المحركات بالإضافة لـ firebaseConfig (التي طلبناها مسبقاً للوحة الإدارة)
export { db, auth, storage, firebaseConfig };